<template>
  <div id="app">

    <nav class="navbar navbar-expand-lg navbar-light bg-orange mb-5">

      <p class="navbar-brand ml-3 text-light font-weight-light mx-auto text-center mb-0">Song Export</p>

    </nav>

    <router-view></router-view>


  </div>
</template>

<script>


export default {
  name: 'App',
}
</script>


<style>
  .bg-orange {
    background-color: #F2B471 !important;
  }
  .menu-light {
    color: #9B9B9B !important;
  }
  .menu-dark {
    color: #4A4A4A !important;
  }

 .table thead th {
   font-weight: 400;
   color: #4A4A4A !important;
 }

</style>
